import React, { createContext, useState, useContext, useEffect } from "react";
import { translations } from "./translations";

const LanguageContext = createContext();

export const LanguageProvider = ({ children }) => {
  const getBrowserLanguage = () => {
    const browserLang = navigator.language || navigator.userLanguage;
    return browserLang.startsWith("pt") ? "pt" : "en";
  };

  const [language, setLanguage] = useState(getBrowserLanguage());
  const [texts, setTexts] = useState(translations[getBrowserLanguage()]);

  useEffect(() => {
    setTexts(translations[language]);
  }, [language]);

  const toggleLanguage = () => {
    setLanguage((prevLang) => (prevLang === "en" ? "pt" : "en"));
  };

  return (
    <LanguageContext.Provider value={{ language, texts, toggleLanguage }}>
      {children}
    </LanguageContext.Provider>
  );
};

export const useLanguage = () => useContext(LanguageContext);
